<main class="c-main wow-consulta">
  <div class="container-fluid">
    <div class="mat-elevation-z8">
      <mat-card>
        <div class="wow-consulta__header">
          <div class="wow-consulta__header-icon"><mat-icon>apps</mat-icon></div>
          <mat-card-title>Segmentos (Sistemas)</mat-card-title>
        </div>

        <app-wow-consulta-filtros
          [tipoFiltros]="tipoFiltros"
          [(tipoFiltro)]="tipoFiltro"
          [(parametro)]="parametro"
          [parametroMask]="tipoFiltro === 'ID' ? 'separator.0' : ''"
          [showSituacao]="true"
          [(situacao)]="situacao"
          (consultar)="consultar()"
          (novo)="novo()">
        </app-wow-consulta-filtros>

        <div class="wow-consulta__empty" *ngIf="!consultaRealizada">
          Clique em <strong>Consultar</strong> para listar os sistemas cadastrados.
        </div>

        <table *ngIf="consultaRealizada" mat-table [dataSource]="segmentos" class="full-width">
          <ng-container matColumnDef="codigo">
            <th mat-header-cell *matHeaderCellDef>Código</th>
            <td mat-cell *matCellDef="let s">{{ s.codigo }}</td>
          </ng-container>
          <ng-container matColumnDef="nome">
            <th mat-header-cell *matHeaderCellDef>Nome</th>
            <td mat-cell *matCellDef="let s">{{ s.nome }}</td>
          </ng-container>
          <ng-container matColumnDef="descricao">
            <th mat-header-cell *matHeaderCellDef>Descrição</th>
            <td mat-cell *matCellDef="let s">{{ s.descricao || '—' }}</td>
          </ng-container>
          <ng-container matColumnDef="ordem">
            <th mat-header-cell *matHeaderCellDef>Ordem</th>
            <td mat-cell *matCellDef="let s">{{ s.ordem ?? '—' }}</td>
          </ng-container>
          <ng-container matColumnDef="ativa">
            <th mat-header-cell *matHeaderCellDef>Situação</th>
            <td mat-cell *matCellDef="let s">{{ s.ativo !== false ? 'Ativo' : 'Inativo' }}</td>
          </ng-container>
          <ng-container matColumnDef="acoes">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let s" (click)="$event.stopPropagation()">
              <button mat-icon-button color="accent" matTooltip="Alterar" (click)="editar(s)">
                <mat-icon>edit</mat-icon>
              </button>
              <button mat-icon-button color="warn" matTooltip="Inativar" (click)="inativar(s)" *ngIf="s.ativo !== false">
                <mat-icon>delete</mat-icon>
              </button>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="['codigo','nome','descricao','ordem','ativa','acoes']"></tr>
          <tr mat-row *matRowDef="let row; columns: ['codigo','nome','descricao','ordem','ativa','acoes'];"
            class="wow-consulta__row" (click)="editar(row)"></tr>
        </table>
      </mat-card>
    </div>
  </div>
</main>
